class XmlSubTitleParser {
  constructor(score) {
    this.score = score;
    this.lyricsXml = null;
  }

  timestampFromTimeString = timeString => {
    const timestamp = timeString.split('.').reduce((accumulator, currentValue, index) => {
      if (index === 0) return accumulator + parseInt(currentValue) * 60 * 1000;
      if (index === 1) return accumulator + parseInt(currentValue) * 1000;
      //if(index === 2)
      return accumulator + parseInt(currentValue);
    }, 0);
    return timestamp;
  };

  getSubTitlesFromXmlDocument = () => {
    const doc = this.lyricsXml;
    const subtitles = [];
    let lastWord = null;
    doc.querySelectorAll('line').forEach((lineElement, index) => {
      let line = [];
      const cues = lineElement.querySelectorAll('cue');
      cues.forEach((cue, index) => {
        const word = {};
        word.start = this.timestampFromTimeString(cue.getAttribute('start'));
        // se il precedente tag non aveva la fine la setto come start del successivo
        // questo funziona perchè lastword è un riferimento a word.
        if (lastWord && !lastWord.end) lastWord.end = word.start;
        word.text = cue.innerHTML;
        if (cue.hasAttribute('end')) word.end = this.timestampFromTimeString(cue.getAttribute('end'));
        line.push(word);
        lastWord = word;
      });
      subtitles.push(line);
    });
    return subtitles;
  };

  async loadLyricsXml() {
    const url = process.env.PUBLIC_URL + '/music' + this.score.path + '/lyrics.xml';
    const res = await fetch(url);
    const xml = await res.text();
    this.lyricsXml = new window.DOMParser().parseFromString(xml, 'text/xml');
    console.log("lyricsXml:",this.lyricsXml);
  }

  async parse() {
    if (this.lyricsXml===null) await this.loadLyricsXml().finally();
    return this.getSubTitlesFromXmlDocument();
  }
}

export default XmlSubTitleParser;
